//import axios from 'axios'
//import {API_BASE} from '../config'

export default class {

    constructor() {
        //heroku
        // this.apiToken = '$2y$10$7ucEJMDN7gIUjT3ekVDGHOuhX8ANfDOaVfV5vjE3lTO4LlWPhg9ua';
        // this.market_app_name = "gw_melon";
        //used 
        // this.apiToken = '$2y$10$0JXSvkSvP1hPKTheUBvQcewPYjl2Q0wZmhMuCdPhNJPhqFZ.stKo2';
        // this.market_app_name = "ntm_melon"; 
        //used
        this.apiToken = '$2y$10$fqnlA9HkTRJS7aqwAK/7CuAfeHCXpDWclotaaVmn611gfVGHH0/1a'; 
        this.market_app_name = "stanelworld"; 
        this.app_url = "https://radar.io";
        this.app_name = "Stanel World";
        this.sp_url = "https://wspk.herokuapp.com";
        this.siteUrl = 'http://share.sellpoints.com.ng/';
        this.video_exts = ['mp4','mp3'];
        this.general_banner_image = "/static/assets/images/banner-general.jpg";
        this.upload_wait_period = 60000; //40sec 
        this.max_media_upload = "7MB"; //40sec 
        //heroku
        // this.baseURL = 'https://spap.herokuapp.com/';
        // this.baseURL = 'https://spap.afiahub.com/api/';
        this.baseURL = 'https://spattle.afiahub.com/api/';
       
        //cloud files
        this.imageSellpointsURL = '';
        this.imageProductsURL = '';
        this.imageUsersURL = '';



        
    }

    //settings
    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        currency =  currency.replace("₦", "") //if sign showing as in Edge browser
        currency =  currency.replace("NGN", ""); //strip off NGN
        return currency;
    }
    //------data services
    //get states
    getStates(context, id) {
        return context.$http.get(this.baseURL+'states', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get cities
    getCities(context, id) {
        return context.$http.get(this.baseURL+'cities/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    ///----business-market-app-services

    //users

    // User registration
    regUser(context, data) {
        return context.$http.post(this.baseURL + 'users', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    }
    // Loging in user
    loginUser(context, data) {
        return context.$http.post(this.baseURL + 'app/admin/login', data, {
            headers: {
               'Origin-Host': this.apiToken
           }
       });
    }

    //
    activateUserToken(context, id) {
        return context.$http.get(this.baseURL + 'settings/activate/user/token/'+id,  {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

     //forgot password
     forgotPassword(context, data) {
        return context.$http.post(this.baseURL + 'settings/password/forgot', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
       });
    }

    //verify reset password token
    verifyResetPasswordToken(context, id) {
        return context.$http.get(this.baseURL + 'settings/verify/reset/token/'+id,  {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //reset forgot password
    resetForgotPassword(context, data) {
        return context.$http.post(this.baseURL + 'settings/password/forgot/reset', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //reset password
    resetPassword(context, data) {
        return context.$http.post(this.baseURL + 'settings/password/reset', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //change email
    changeEmail(context, data) {
        return context.$http.post(this.baseURL + 'settings/email/reset', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //session guard
    // sessionGuard(context, data) {
    //     return context.$http.post(this.baseURL + 'auth/sessions', data, {
    //         headers: {
    //             'Origin-Host': this.apiToken
    //         }
    //     });
    // }

    //session-guard-updated
    sessionGuard(context, data) {
        //before return check if passed
        //if not call session reauth
        //then return sessoin reauth data
        ///....
        //.....also once called provide or rewrite new session details if success
        //.....provide null or undefined defaults as session details 
        //..///this is to help headers and co pick accurate session details without preseting
        return context.$http.post(this.baseURL + 'auth/app/admin/sessions', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //session sync set
    sessionSyncSet(context, id) {
        return context.$http.get(this.baseURL + 'auth/sessions/sync/'+id,  {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //session sync
    sessionSync(context, data) {
        return context.$http.post(this.baseURL + 'auth/sessions/sync', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    // Check User details
    checkUserDetails(context, data) {
        return context.$http.post(this.baseURL + 'users/checks', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //edit user
    editProfileDetails(context, data) {
        return context.$http.put(this.baseURL + 'users', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //--users

    //post subscriptions request
    makeAppSubscriptionOrder(context, data) {
        return context.$http.post(this.baseURL + 'app/businesses/subscription/orders', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    
    }

    //update
    updateAppSubscriptionOrder(context, data) {
        return context.$http.post(this.baseURL + 'app/businesses/subscription/orders/updates', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //businesses
    //can edit a sellpoint
    can_edit(context, data) {
        return context.$http.post(this.baseURL + 'auth/validate/ownership', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    
    }
    //get business market
    getBusinessMarket(context, id) {
        return context.$http.get(this.baseURL + 'businesses/markets/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //get all users businesses
    getBusinesses(context, id) {
        return context.$http.get(this.baseURL+'businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get all users businesses
    getAppBusinesses(context, id) {
        return context.$http.get(this.baseURL+'app/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get single business
    getBusinessByUserName(context, id) {
        return context.$http.get(this.baseURL+'businesses/usernames/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    
    //get single business
    getAppBusinessByUserName(context, id) {
        return context.$http.get(this.baseURL+'app/businesses/usernames/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    //get business products
    getBusinessProducts(context, id) {
        return context.$http.get(this.baseURL + 'products/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    getAppBusinessProducts(context, id, limit) {
        return context.$http.get(this.baseURL + 'products/app/businesses/'+id+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    addNewBusiness(context, data) {
        return context.$http.post(this.baseURL + 'businesses/new', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    addExistingBusiness(context, data) {
        return context.$http.post(this.baseURL + 'businesses/existing', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //validateUserName
    validateBusinessUserName(context, data) {
        return context.$http.post(this.baseURL + 'businesses/validate/username', data, {
            headers: {
               'Origin-Host': this.apiToken
           }
       });
    }

    getBusinessMarketUpgradeDetails(context, id) {
        return context.$http.get(this.baseURL + 'app/businesses/markets/upgrades/'+id, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }

    upgradeBusinessMarketSubscription(context, data) {
        return context.$http.post(this.baseURL + 'app/businesses/markets/upgrades', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }

    //get business categories
    getCategories(context) {
        return context.$http.get(this.baseURL+'categories', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get main categories in parent
    getMainCategories(context,id) {
        return context.$http.get(this.baseURL+'categories/main/'+id, {
            headers: {
                'Origin-Host': this.apiToken
            }
        })
    }

    //get sub  business categories
    getBusinessSubCategories(context,id) {
        return context.$http.get(this.baseURL+'categories/'+id, {
            headers: {
                'Origin-Host': this.apiToken
            }
        })
    }

    //get business categories
    getBusinessCategories(context,id) {
        return context.$http.get(this.baseURL+'businesses/categories/'+id, {
            headers: {
                'Origin-Host': this.apiToken
            }
        })
    }


    addGallery(context, data) {
        return context.$http.post(this.baseURL + 'posts/gallery', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }

    getPointGalleryPosts(context, id, offset, limit, posts_offset, posts_limit) {
        return context.$http.get(this.baseURL + 'posts/gallery/points/'+id+'/'+offset+'/'+limit+'/'+posts_offset+'/'+posts_limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get single gallery with name search
    getGallerySearch(context, id) {
        return context.$http.get(this.baseURL+'posts/gallery/url/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //Edit business details
    editBusinessDetails(context, data) {
        return context.$http.put(this.baseURL + 'businesses/details', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //businesses set processing fees options
    setShippingFeeStatus(context, data) {
        return context.$http.put(this.baseURL + 'businesses/setshippingfeestatus', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

     //Add delivery_option to business
     addDeliveryOption(context, data) {
        return context.$http.post(this.baseURL + 'businesses/deliveryoptions', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Edit DeliveryOptions to business
    editDeliveryOption(context, data) {
        return context.$http.put(this.baseURL + 'businesses/deliveryoptions', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Delete DeliveryOptions to business
    deleteDeliveryOption(context, id, data) {
        return context.$http.put(this.baseURL + 'businesses/deliveryoptions/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    
    //business processing fee switch
    switchProcessingFeePay(context, data) {
        return context.$http.put(this.baseURL + 'businesses/processingfees', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get business discounts and coupons
    getBusinessDiscountsAndCoupons(context, id) {
        return context.$http.get(this.baseURL + 'businesses/discounts/coupons/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //set business discounts and coupons
    setDiscountsAndCoupons(context, data) {
        return context.$http.post(this.baseURL + 'businesses/discounts/coupons', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit business discounts and coupons
    editDiscountsAndCoupons(context, data) {
        return context.$http.put(this.baseURL + 'businesses/discounts/coupons', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //deactivate business discounts and coupons
    deactivateDiscountsAndCoupons(context, data) {
        return context.$http.put(this.baseURL + 'businesses/discounts/coupons/deactivate', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
 

    //businesses

    //products

    //get sproduct images
    getProductImages(context, id) {
        return context.$http.get(this.baseURL+'products/images/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    deleteProductImage(context, id) {
        return context.$http.delete(this.baseURL+'products/images/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    //./products
    //uploads
    //Upload Image
    uploadDataPhoto(context, data) {
        return context.$http.post(this.baseURL + 'uploads', data, {
             headers: {
               'Origin-Host': this.apiToken,
               'Content-Type': 'multipart/form-data',
            }
        });
    }
    
    //Upload Business Images
    uploadBusinessDataPhoto(context, data) {
        return context.$http.post(this.baseURL + 'businesses/uploads', data, {
             headers: {
               'Origin-Host': this.apiToken,
               'Content-Type': 'multipart/form-data',
            }
        });
    }
    //..uploads


    ////--------gw-services

    

    //get single user
    getUser(context, id) {
        return context.$http.get(this.baseURL+'users/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }


    //businesses local 

    getProductsInBusinessCategories(context, id) {
        return context.$http.get(this.baseURL + 'products/businesses/categories/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get market categories
    getMarketCategories(context) {
        return context.$http.get(this.baseURL+'market/categories', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get site filters
    getFilters(context) {
        return context.$http.get(this.baseURL+'filters', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //Add business
    addBusiness(context, data) {
        return context.$http.post(this.baseURL + 'businesses', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }





    

    //get business products
    getBusinessNotifications(context, id) {
        return context.$http.get(this.baseURL + 'notifications/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get business messages
    getBusinessMessages(context, id) {
        return context.$http.get(this.baseURL + 'messages/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //get business orders
    getBusinessOrders(context, id) {
        return context.$http.get(this.baseURL + 'orders/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //read notifications
    readNotifications(context, data) {
        return context.$http.post(this.baseURL + 'notifications/general/updates', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    }





    //categories
    //Add category to business
    addCategory(context, data) {
        return context.$http.post(this.baseURL + 'businesses/categories', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Edit category to business
    editCategory(context, data) {
        return context.$http.put(this.baseURL + 'businesses/categories', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //products calls
    //get products
    getProducts(context,offset,limit) {
        return context.$http.get(this.baseURL + 'products/all/'+offset+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

   
    //get market products
    getMarketProducts(context, id) {
        return context.$http.get(this.baseURL + 'products/markets/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get market activity products
    getMarketActivityProducts(context, id, offset, limit) {
        return context.$http.get(this.baseURL + 'products/markets/activities/'+id+'/'+offset+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

     //get business market
     getBusinessMarket(context, id) {
        return context.$http.get(this.baseURL + 'businesses/markets/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get category products
    getCategoryProducts(context, id) {
        return context.$http.get(this.baseURL + 'products/categories/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //search category products
    searchCategoryProducts(context, name, type) {
        return context.$http.get(this.baseURL + 'products/search/categories/'+name+'/'+type, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //searchproducts
    searchProducts(context, search) {
        return context.$http.get(this.baseURL + 'products/search/'+search, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //searchbusinessproducts
    searchBusinessProducts(context, search) {
        return context.$http.get(this.baseURL + 'products/search/businesses/'+search, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //get single products with name search
    getProductSearch(context, id) {
        return context.$http.get(this.baseURL+'products/product/url/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //Add products
    addProduct(context, data) {
        return context.$http.post(this.baseURL + 'products', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }
    addProductItem(context, data) {
        return context.$http.post(this.baseURL + 'products/items', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    // Add product details
    addProductDetail(context, data) {
        return context.$http.post(this.baseURL + 'products/details', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
       });
    }

    // Add product reviews
    addProductReview(context, data) {
        return context.$http.post(this.baseURL + 'products/reviews', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
       });
    }

    //edit product
    editProduct(context, id, data) {
        return context.$http.put(this.baseURL + 'products/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit product settings
    editProductSettings(context, id, data) {
        return context.$http.put(this.baseURL + 'products/settings/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    
    //edit product item single
    editProductItemSingle(context, id, data) {
        return context.$http.put(this.baseURL + 'products/items/singles/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit product item
    editProductItem(context, id, data) {
        return context.$http.put(this.baseURL + 'products/items/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }


    //remove product item
    removeProductItem(context, id, data) {
        return context.$http.put(this.baseURL + 'products/items/remove/'+id, data,{
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit product item group
    editProductItemGroup(context, id, data) {
        return context.$http.put(this.baseURL + 'products/itemgroups/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //remove product item group
    removeProductItemGroup(context, id, data) {
        return context.$http.put(this.baseURL + 'products/itemgroups/remove/'+id, data,{
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //remove product item
    removeProduct(context, id, data) {
        return context.$http.put(this.baseURL + 'products/remove/'+id, data,{
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit product info
    // editProductInformation(context, data) {
    //     return context.$http.put(this.baseURL + 'products/information', data, {
    //          headers: {
    //            'Origin-Host': this.apiToken
    //         }
    //     });
    // }

    //
    editProductDetail(context, id, data) {
        return context.$http.put(this.baseURL + 'products/details/'+id, data, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //delete product detail
    deleteProductDetail(context, id, data) {
        return context.$http.delete(this.baseURL + 'products/details/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get product delivey
    getProductDeliveryOptions(context, id) {
        return context.$http.get(this.baseURL + 'products/delivery/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //product delivery
    setProductDelivery(context, id, data) {
        return context.$http.put(this.baseURL + 'products/delivery/'+id, data, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    setProductShippingFeeStatus(context, data) {
        return context.$http.put(this.baseURL + 'products/set/shippingfeestatus', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //Set Product Delivery Options 
    setProductDeliveryOption(context, data) {
        return context.$http.post(this.baseURL + 'products/delivery/fees', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //product info
    getProductInformation(context, id) {
        return context.$http.get(this.baseURL + 'products/information/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //add product info
    addProductInformation(context, data) {
        return context.$http.post(this.baseURL + 'products/information', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
       });
   }
    //
    editProductInformation(context, id, data) {
        return context.$http.put(this.baseURL + 'products/information/'+id, data, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //delete product detail
    deleteProductInformation(context, id, data) {
        return context.$http.delete(this.baseURL + 'products/information/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //./product info

    //gallery info
    //edit gallery
    editGallery(context, id, data) {
        return context.$http.put(this.baseURL + 'posts/gallery/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //delete gallery
    deleteGallery(context, id) {
        return context.$http.delete(this.baseURL + 'posts/gallery/'+id, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit gallery post
    editGalleryPost(context, id, data) {
        return context.$http.put(this.baseURL + 'posts/gallery/posts/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }


    //delete gallery post
    deleteGalleryPost(context, id) {
        return context.$http.delete(this.baseURL + 'posts/gallery/posts/'+id, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //./posts
    //./gallery info
    
    //reset
    resetData(context, type, id) {
        return context.$http.get(this.baseURL+'data/reset/'+type+'/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    deleteImages(context, id, data) {
        return context.$http.put(this.baseURL+'data/images/'+id, data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    
    //checkout
    checkout(context, data) {
        return context.$http.post(this.baseURL + 'orders', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

     //checkout orders
     getCheckoutOrder(context, url) {
        return context.$http.get(this.baseURL + 'orders/url/'+url, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //checkout orders
    getCheckoutOrders(context, id) {
        return context.$http.get(this.baseURL + 'orders/topays/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //checkout orders
    getUserDeliveryDetails(context, id) {
        return context.$http.get(this.baseURL + 'users/deliverydetails/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //update
    updatePayment(context, data) {
        return context.$http.post(this.baseURL + 'payments', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //get orders
    getOrders(context, id) {
        return context.$http.get(this.baseURL + 'orders/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //services
    //Add service to business
    addService(context, data) {
        return context.$http.post(this.baseURL + 'businesses/services', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Edit services to business
    editService(context, data) {
        return context.$http.put(this.baseURL + 'businesses/services', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //product info
    getBusinessDeliveryOptions(context, id) {
        return context.$http.get(this.baseURL + 'businesses/deliveryoptions/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //product info
    checkBusinessPayOnDelivery(context, id) {
        return context.$http.get(this.baseURL + 'businesses/checkdeliveryoptions/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //business contact form
    sendBusinessContactForm(context, data) {
        return context.$http.post(this.baseURL + 'businesses/contacts', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //business filter options
    setBusinessFilterOptions(context, data) {
        return context.$http.put(this.baseURL + 'businesses/filters', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    removeBusinessFilterOption(context, data) {
        return context.$http.post(this.baseURL + 'businesses/filters', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //business bank details
    setBusinessBankDetails(context, data) {
        return context.$http.put(this.baseURL + 'businesses/bankdetails', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }


    
}


// WEBPACK FOOTER //
// ./src/services/service.js